<form [formGroup]="staffForm" (ngSubmit)="onSubmit()">
    <div class="row">
        <div class="col-12 col-xl-8">
            <mat-card class="rounded-4">
                <mat-card-content class="p-4">
                    <div class="d-flex flex-row gap-3 align-items-center justify-content-between mb-3">
                        <div class="">
                            <h5 class="">Staff Account Creation</h5>
                        </div>
                    </div>  
    
                    <div class="row g-3">
                        <div class="col-12 col-md-6">
                            <mat-form-field class="w-100" appearance="outline">
                              <mat-label>Name</mat-label>
                                <input matInput formControlName="name" placeholder="Ex. Dhoni">
                                <mat-error *ngIf="f['name']?.hasError('required')">Name is required</mat-error>
                                <mat-error *ngIf="f['name']?.hasError('minlength')">Min 3 characters</mat-error>
                                <mat-error *ngIf="f['name']?.hasError('pattern')">Only letters and spaces</mat-error>
                            </mat-form-field>
                        </div>  
                        <div class="col-12 col-md-6">
                            <mat-form-field class="w-100" appearance="outline">
                                <mat-label>Staff Id</mat-label>
                                <input matInput formControlName="staffId" placeholder="Ex. 123456">
                                <mat-error *ngIf="f['staffId']?.hasError('required')">Staff Id is required</mat-error>
                                <mat-error *ngIf="f['staffId']?.hasError('pattern')">Only alphanumeric is accepted</mat-error>
                            </mat-form-field>
                        </div>  
                        <div class="col-12 col-md-6">
                            <mat-form-field class="w-100" appearance="outline">
                                <mat-label>Phone</mat-label>
                                <input matInput formControlName="phone" placeholder="Ex. 88XX25X65">
                                <mat-error *ngIf="f['phone']?.hasError('required')">Phone Number is required</mat-error>
                                <mat-error *ngIf="f['phone']?.hasError('pattern')">Only 10 digits accepted</mat-error>
                            </mat-form-field>
                        </div>  
                        <div class="col-12 col-md-6">
                            <mat-form-field class="w-100" appearance="outline">
                                <mat-label>Designation</mat-label>
                                <mat-select formControlName="designation">
                                    <mat-option *ngFor="let desigation of desigations" [value]="desigation">{{desigation}}</mat-option>
                                </mat-select>
                                <mat-error *ngIf="f['designation'].hasError('required')">Designation is required</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-md-6">
                            <mat-form-field class="w-100" appearance="outline">
                                <mat-label>Staff Course</mat-label>
                                <mat-select multiple formControlName="staffCourse" aria-multiselectable="true">
                                    <mat-option *ngFor="let course of courses" [value]="course.id">{{course.name}}</mat-option>
                                </mat-select>
                                <mat-error *ngIf="f['staffCourse']?.hasError('required')">Course is required</mat-error>
                                <mat-error *ngIf="f['staffCourse']?.hasError('minSelected')"> At least one selection</mat-error>    
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-md-6">
                            <mat-form-field class="w-100" appearance="outline">
                                <mat-label>Email</mat-label>
                                <input matInput formControlName="email" placeholder="Ex. xyz@.com">
                                <mat-error *ngIf="f['email']?.hasError('required')">Phone Number is required</mat-error>
                                <mat-error *ngIf="f['email']?.hasError('email')">Valid email format</mat-error>    
                            </mat-form-field>
                        </div>  
                        <div class="col-12 col-md-12">
                            <mat-form-field class="w-100" appearance="outline">
                                <mat-label>Password</mat-label>
                                <input matInput type="password" formControlName="password" placeholder="Ex. @#45gh">
                                <mat-error *ngIf="f['password']?.hasError('required')">Password is required</mat-error>
                                <mat-error *ngIf="f['password']?.hasError('pattern')">Required, Min length 6, at least 1 number, 1 special character</mat-error>    
                                <mat-error *ngIf="f['password']?.hasError('minlength')">Min length 6</mat-error>    
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-md-12">
                            <mat-form-field class="w-100" appearance="outline">
                                <mat-label>Confirm Password</mat-label>
                                <input matInput type="password" formControlName="confirmPassword" placeholder="Ex. @#45gh">
                                <mat-error *ngIf="f['confirmPassword']?.hasError('required')">Confirm Password is required</mat-error>
                                <mat-error *ngIf="f['confirmPassword']?.hasError('mismatch')">Passwords do not match</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-md-12">
                            <div class="d-flex gap-3">
                                <button mat-flat-button color="primary" class="px-4">Create Profile</button>
                                <button mat-stroked-button class="px-4">Reset</button>
                            </div>
                        </div>
                    </div><!--end row-->
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</form>